import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@quintoandar-tokko/jopijs';
import style from './pendingLeads.module.scss';
import SingleUserCard from './pendingLeadsCard/SingleUserCard';
import MultipleEntityCard from './pendingLeadsCard/MultipleEntityCard';
import RemainingEntitiesCard from './pendingLeadsCard/RemainingEntitiesCard';
import { showCardSeparator } from '../utils';
import {
  AGENT,
  BRANCH,
} from '@/components/FilterBar/constants/filtersConstants';

function PendingLeadsContainer({ trackCallback = null }) {
  const { leads } = useSelector((state) => state.DashboardSlice.pendingLeads);
  const { selectedIds } = useSelector((state) => state.FilterBarSlice.filters);
  const filterType = selectedIds.some((el) => el.filter_type === AGENT)
    ? AGENT
    : BRANCH;

  const lastCardIndex = 3;
  const showMultipleEntity = selectedIds.length > 1;
  const showSingleAgentLeads = !showMultipleEntity;

  const remainingLeads = [...leads].slice(lastCardIndex);

  return (
    <Box className={style.pendingLeadsContainer}>
      {showSingleAgentLeads &&
        leads.map((lead, index) => (
          <Box key={lead.id}>
            <SingleUserCard lead={lead} trackCallback={trackCallback} />
            {showCardSeparator(index, leads) && (
              <Box className={style.separator} />
            )}
          </Box>
        ))}
      {showMultipleEntity &&
        leads.map((lead, index) => (
          <Box key={lead.agent_id || lead.branch_id}>
            {index < lastCardIndex && (
              <MultipleEntityCard
                type={filterType}
                lead={lead}
                count={lead.count}
                trackCallback={trackCallback}
              />
            )}
            {index === lastCardIndex && (
              <RemainingEntitiesCard leads={remainingLeads} type={filterType} />
            )}
            {showCardSeparator(index, leads) && (
              <Box className={style.separator} />
            )}
          </Box>
        ))}
    </Box>
  );
}

export default PendingLeadsContainer;
